import React, { useEffect, useState } from "react";
import "../../App.css";
import "@nutui/nutui-react/dist/style.css";
import { paramObj } from "../../utils";
import InfoLabel from "./children/InfoLabel";
import { LOG_URL } from "../../utils/contant";
import { fitterImages } from "./contant";
import { Overlay, Input, Toast } from "@nutui/nutui-react";
import ImgPreview from "./children/ImgPreview";
import Seizure from "./children/Seizure";
import "../../tac/css/tac.css";
import VerifySlide from "../verify/verifySlide";
import "../verify/index.css";
import { getCertResult, checkNumber } from "../../api/index";

function RegisterApp(props) {
   const url = props?.url
  //const url ="http://192.168.4.101:30563/?blockCertNumber=黔作登字-2025-F-00000122";
  const registernumber =
    paramObj(url)["registerCertNumber"] || paramObj(url)["blockCertNumber"];
  const QIAN = registernumber.search("黔作登字") !== -1;
  const [listData, setListData] = useState("");
  const [isBlock, setIsBlock] = useState(!QIAN);
  const [imgs, setImgs] = useState([]);
  const Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  const agent = window.navigator.userAgent;
  //  const wxAgent = Agents.some(i=>agent.indexOf(i)>-1) && agent.toLowerCase().indexOf('micromessenger') > -1
  const wxAgent = true;
  const [visible, setVisible] = useState(true);
  const [idCardLastSix, setIdCardLastSix] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [idCardVerified, setIdCardVerified] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [idCardLoading, setIdCardLoading] = useState(false);

  // 验证身份证后六位
  const validateIdCard = (value) => {
    if (!value || value.length !== 6) {
      return false;
    }
    return true;
  };

  // 处理身份证输入变化
  const handleIdCardChange = (value) => {
    setIdCardLastSix(value);
    setErrorMessage("");
    setIdCardVerified(false); // 重置验证状态

    if (validateIdCard(value)) {
      setIdCardLoading(true);
      // 调用接口验证身份证后六位
      checkNumber({
        registernumber: registernumber,
        number: value,
      })
        .then((res) => {
          setIdCardLoading(false);
          if (res.code === 200) {
            setIdCardVerified(true);
          } else {
            setIdCardVerified(false);
            setErrorMessage(res.repMsg || "证件号验证失败");
           // Toast.show(res.repMsg || "身份证验证失败");
          }
        })
        .catch((err) => {
          setIdCardLoading(false);
          setIdCardVerified(false);
          setErrorMessage("证件号验证失败，请重试");
        //  Toast.show("身份证验证失败，请重试");
        });
    } else {
      setIdCardVerified(false);
    }
  };

  // 处理两个验证都通过的情况
  const handleBothVerified = (res) => {
    setVisible(false);
    const data = {
      registernumber: registernumber,
      captchaVerification: encodeURIComponent(res.captchaVerification),
      number: idCardLastSix,
    };
    getCertResult(data).then((r) => {
      setListData(r?.data?.id || {});
      const registerCertificateUrl = r?.data?.id?.registerCertificateUrl;
      if (registerCertificateUrl) {
        setImgs(fitterImages(registerCertificateUrl.split(",")));
      }
    });
  };

  // 验证码成功回调
  const succeess = (res) => {
    setCaptchaVerified(true);
    setErrorMessage("");

    // 检查是否两个验证都通过
    if (idCardVerified) {
      // 两个验证都通过，关闭弹窗并发送请求
      handleBothVerified(res);
    } else {
      setErrorMessage("第一著作权人证件号后六位");
     // Toast.show("第一著作权人证件号后六位");
    }
  };

  useEffect(() => {
    if (registernumber) {
      // const config = {
      //     requestCaptchaDataUrl: `${HOST}captcha/generate-slider`,
      //     validCaptchaUrl: `${HOST}captcha/check?registernumber=${registernumber}`,
      //     bindEl: "#captcha-div",
      //     // 验证成功回调函数
      //     validSuccess: (res, c, tac) => {
      //         setVisible(false)
      //         setListData(res?.data?.id || {});
      //         const registerCertificateUrl = res?.data?.id?.registerCertificateUrl
      //         if (registerCertificateUrl) {
      //             setImgs(fitterImages(registerCertificateUrl.split(',')))
      //         }
      //         tac.destroyWindow();
      //     }
      // }
      // let style = {
      //     logoUrl: null, moveTrackMaskBgColor: "#1991fa",
      //     moveTrackMaskBorderColor: "#333"
      // }
      // new window.TAC(config, style).init();
    }
  }, [registernumber]);

  return (
    <div className="App" style={{ paddingBottom: "20px" }}>
      {!wxAgent ? (
        <div
          style={{ paddingTop: "40vh", textAlign: "center", fontSize: "20px" }}
        >
          请用手机在微信浏览器中打开
        </div>
      ) : (
        <>
          <Overlay visible={visible}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  maxWidth: "350px",
                }}
              >
                {/* 身份证后六位输入框 */}
                <div style={{ marginBottom: "20px" }}>
                  <div
                    style={{
                      fontSize: "16px",
                      marginBottom: "10px",
                      color: "#333",
                        textAlign: 'left',
                      fontWeight:'bold'
                    }}
                  >
                    证件号后六位:
                  </div>
                  <div style={{ position: "relative" }}>
                    <Input
                      placeholder="请输入第一著作权人证件号后六位"
                      value={idCardLastSix}
                      onChange={handleIdCardChange}
                      maxLength={6}
                      disabled={idCardLoading}
                      style={{
                        border: idCardVerified
                          ? "2px solid #52c41a"
                          : idCardLoading
                          ? "2px solid #1890ff"
                          : "2px solid #d9d9d9",
                        borderRadius: "4px",
                        padding: "8px 12px",
                        fontSize: "16px",
                        backgroundColor: idCardLoading ? "#f5f5f5" : "#fff",
                      }}
                    />
                    {idCardLoading && (
                      <div
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          fontSize: "14px",
                          color: "#1890ff",
                        }}
                      >
                        验证中...
                      </div>
                    )}
                  </div>
                  {errorMessage && (
                    <div
                      style={{
                        color: "#ff4d4f",
                        fontSize: "14px",
                        marginTop: "5px",
                      }}
                    >
                      {errorMessage}
                    </div>
                  )}
                </div>

                {/* 验证码组件 */}
                <VerifySlide succeess={succeess} />

                {/* 验证状态提示 */}
                <div style={{ marginTop: "15px", textAlign: "center" }}>
                  <div style={{ fontSize: "14px", color: "#666" }}>
                    {idCardLoading && (
                      <span style={{ color: "#1890ff", marginRight: "10px" }}>
                        ⏳ 身份证验证中...
                      </span>
                    )}
                    {idCardVerified && !idCardLoading && (
                      <span style={{ color: "#52c41a", marginRight: "10px" }}>
                        ✓ 身份证验证通过
                      </span>
                    )}
                    {captchaVerified && (
                      <span style={{ color: "#52c41a" }}>✓ 验证码验证通过</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Overlay>

          {!visible && (
            <>
              <img src={LOG_URL} style={{ width: 380 }} />
              <InfoLabel
                style={{ paddingLeft: "12px", paddingRight: "12px" }}
                isBlock={isBlock}
                listData={listData}
              />
              {listData.registerBuildStatus === 3 && (
                <Seizure list={listData.seizureList} />
              )}
              {listData.registerBuildStatus !== 3 && imgs.length ? (
                <div style={{ marginTop: "20px" }}>
                  <ImgPreview images={imgs} />
                </div>
              ) : null}
            </>
          )}
        </>
      )}
    </div>
  );
}

export default RegisterApp;
